import React from 'react';

'use strict';

export default class VideoPlayer extends React.Component {
    constructor(props) {
        super(props);
        this.onPlayerInitialized = this.onPlayerInitialized.bind(this);
        this.onVideoStarted = this.onVideoStarted.bind(this);
        this.onVideoPlaying = this.onVideoPlaying.bind(this);
        this.onVideoProgress = this.onVideoProgress.bind(this);
        this.onVideoSeeked = this.onVideoSeeked.bind(this);
        this.onVideoEnded = this.onVideoEnded.bind(this);
    }

    componentDidMount() {
        this.seekToBookmark = this.props.seekToBookmark;

        this.player = TWNPlayer.init('player', {
            isci: this.props.asset.isci,
            language: this.props.language,
            autoplay: this.props.autoPlay,
            playsinline: true,
            poster: this.props.autoPlay ? null : this.props.asset.posterImagePath
        },
            this.onPlayerInitialized);
    }

    shouldComponentUpdate() {
        return false;
    }

    componentWillUnmount() {
        this.player.dispose();
    }

    updateIsci(isci, language, seekToBookmark) {
        if (!this.player.PlayTWNContent)
            return;

        this.playerState = "initialized";

        this.player.poster(null);
        this.player.pause();
        this.player.autoplay(true);
        this.seekToBookmark = seekToBookmark;

        this.player.PlayTWNContent(isci, language);
    }

    updateBookmark(seekToBookmark) {
        if (this.playerState === 'initialized' && this.seekToBookmark !== seekToBookmark)
            this.seekToBookmark = seekToBookmark;
    }

    onPlayerInitialized() {
        this.playerState = "initialized";

        // Hack: Can't get this attribute to stick from init() above.
        this.player.playerElement().querySelector('video').setAttribute('playsinline', '');

        this.player.addEventListener('start', this.onVideoStarted);
        this.player.addEventListener('playing', this.onVideoPlaying);
        this.player.addEventListener('seeked', this.onVideoSeeked);
        this.player.addEventListener('timeupdate', this.onVideoProgress);
        this.player.addEventListener('ended', this.onVideoEnded);

        // Hacks for accessibility.
        var playerContainer = $(".player-container");
        if (playerContainer) {
            var video = playerContainer.find("video")[0];
            if (video) {
                video.setAttribute("tabindex", "0");
                if (window === window.top) {
                    video.focus();
                }
            }

            var captionsButton = playerContainer.find(".vjs-captions-button")[0];
            if (captionsButton)
                captionsButton.setAttribute("role", "button");

            var fullscreenButton = playerContainer.find(".vjs-fullscreen-control")[0];
            if (fullscreenButton)
                fullscreenButton.setAttribute("aria-label", fullscreenButton.getAttribute("title"));

            playerContainer.find("[aria-hidden=true]").removeAttr("aria-hidden");
            playerContainer.find(".vjs-menu-content, .vjs-menu-item").removeAttr("role");

            window.setTimeout(() => {
                var volumeMenu = playerContainer.find(".vjs-volume-control .vjs-menu")[0];
                if (volumeMenu)
                    volumeMenu.id = "vjs-volume-menu";

                var volumeButton = playerContainer.find(".vjs-volume-control")[0];
                if (volumeButton)
                    volumeButton.setAttribute("aria-controls", "vjs-volume-menu");
            }, 1000);
        }
    }

    onVideoStarted() {
        if (this.playerState === 'started')
            return;

        this.playerState = 'started';

        this.beginReportingInterval = null;

        if (this.props.onVideoStarted)
            this.props.onVideoStarted();
    }

    onVideoPlaying() {
        if (this.seekToBookmark) {
            this.player.currentTime(parseFloat(this.seekToBookmark) * this.player.duration());
            delete this.seekToBookmark;
        }

        this.playerState = 'playing';

        if (this.props.onVideoPlaying)
            this.props.onVideoPlaying(this.player.currentTime(), this.player.duration());
    }

    onVideoSeeked() {
        this.beginReportingInterval = null;

        if (this.props.onVideoSeeked)
            this.props.onVideoSeeked();
    }

    onVideoProgress(e, currentPlayerTime) {

        if (!currentPlayerTime)
            currentPlayerTime = this.player.currentTime();

        if (this.playerState === 'ended' && currentPlayerTime < 1.0)
            this.onVideoStarted();

        if (this.beginReportingInterval)
            if (currentPlayerTime < this.beginReportingInterval || currentPlayerTime < this.lastPlayerTime || (currentPlayerTime > (this.lastPlayerTime + 5)))
                this.onVideoSeeked();
            else
                if (currentPlayerTime > this.endReportingInterval || this.playerState === 'ended') {
                    var timeViewed = currentPlayerTime - this.beginReportingInterval;
                    var duration = this.player.duration();
                    var percentageViewed = timeViewed / duration * 100;

                    if (this.props.onVideoProgress)
                        this.props.onVideoProgress(timeViewed, duration, percentageViewed, this.beginReportingInterval);

                    this.beginReportingInterval = null;
                }

        if (!this.beginReportingInterval) {
            this.beginReportingInterval = currentPlayerTime;

            // Randomize the length of the reporting interval to minimize rounding errors.
            var intervalLength = 10 + 4 * (Math.random() - 0.5);

            // When playback first begins, use a short interval so that we're sure to report initial progress.
            if (this.beginReportingInterval < 1)
                intervalLength = 1;

            this.endReportingInterval = this.beginReportingInterval + intervalLength;
        }

        this.lastPlayerTime = currentPlayerTime;
    }

    onVideoEnded(e) {
        this.playerState = 'ended';

        this.onVideoProgress(e, this.lastPlayerTime);
        if (this.props.onVideoEnded) {
            this.props.onVideoEnded();
        }
    }

    showEndSlate(component) {
        var endSlateContainer = document.getElementById('player-end-slate');

        if (endSlateContainer) {
            $(endSlateContainer).show();
        }
        else {
            $("#player").append('<div id="player-end-slate"></div>');
            endSlateContainer = document.getElementById('player-end-slate');
        }

        ReactDOM.render(component, endSlateContainer);
    }

    hideEndSlate() {
        var endSlateContainer = document.getElementById('player-end-slate');

        if (endSlateContainer) {
            $(endSlateContainer).hide();
            ReactDOM.unmountComponentAtNode(endSlateContainer);
        }
    }

    render() {
        return React.createElement(
            'div',
            {
                id: 'player',
                className: 'player azuremediaplayer amp-default-skin',
                style: { position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }
            }
        );
    }
}